// extracted by mini-css-extract-plugin
export default {"container":"Form_container__ThXv3","wrapper":"Form_wrapper__8MdOv","titles":"Form_titles__8XnSN","buttonWrapper":"Form_buttonWrapper__Z2Y8Z"};